import { TFunction } from 'next-i18next';
import * as yup from 'yup';

import { LoginType } from '@/types/global';

export const loginSchema = (manager: boolean, t: TFunction) => {
  let type = LoginType.TALLERB;
  if (manager) {
    type = LoginType.TALLERB_R;
  }

  let defaultUsername = '',
    defaultPassword = '';
  if (process.env.NODE_ENV === 'development') {
    if (manager) {
      defaultUsername = 'DEVELOPER1';
      defaultPassword = 'ed56kdfr';
    } else {
      defaultUsername = '5200';
      defaultPassword = ' ';
    }
  }

  return yup.object().shape({
    type: yup.string().required().default(type),
    username: yup
      .string()
      .min(1, 'Username must be at least 1 character')
      .max(10, 'Username must be at most 10 characters')
      .required()
      .default(defaultUsername),
    password: yup.string().required().default(defaultPassword),
  });
};
